import React from 'react';
import { MessageSquare, Phone, MapPin, Mail, Award } from 'lucide-react';
import { Card } from '../components/ui/Card';
export function ContactUs() {
  return <div className="min-h-screen bg-gray-50 pt-40 lg:pt-52 pb-20" data-id="element-845" data-mp="2nm7zvxz1smhf">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-846" data-mp="32i5x7jkpjwv8">
        {/* Page Header */}
        <div className="text-center mb-12" data-id="element-847" data-mp="2xhi4mtgtz7yw">
          <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-848" data-mp="2xkntq8pgm9um">Contact Us</h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-849" data-mp="3bg9iqfvp0tn1">
            Our local support team is here to answer your questions about
            classes, requirements, or technical issues.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12" data-id="element-850" data-mp="3g8ssf1r9f4mk">
          {/* Left Column - Contact Form */}
          <Card className="p-6 lg:p-8" data-id="element-851" data-mp="3u8akbpzuqy05">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-852" data-mp="3u93ku987wr9u">
              Send Us An Email Message
            </h2>

            <form className="space-y-4" data-id="element-853" data-mp="3q4vw4c1rfbbm">
              {/* Name */}
              <div data-id="element-854" data-mp="1g0bvazgpyrvf">
                <label htmlFor="name" className="block text-sm font-medium text-gray-900 mb-1" data-id="element-855" data-mp="1g0tti1mxzg5z">
                  Name<span className="text-red-500" data-id="element-856" data-mp="1ozfgc8zg5hck">*</span>
                </label>
                <input type="text" id="name" name="name" required className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500 text-sm" data-id="element-857" data-mp="1tyid7659wh9g" />
              </div>

              {/* Company Name */}
              <div data-id="element-858" data-mp="27sj2l9ac4rx5">
                <label htmlFor="company" className="block text-sm font-medium text-gray-900 mb-1" data-id="element-859" data-mp="2cp002u3fcimw">
                  Company Name
                </label>
                <input type="text" id="company" name="company" className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500 text-sm" data-id="element-860" data-mp="2mmxnxghdgdez" />
              </div>

              {/* E-mail */}
              <div data-id="element-861" data-mp="26qfu0393zjur">
                <label htmlFor="email" className="block text-sm font-medium text-gray-900 mb-1" data-id="element-862" data-mp="26qy1jw181khz">
                  E-mail<span className="text-red-500" data-id="element-863" data-mp="2foi212r9fcrj">*</span>
                </label>
                <input type="email" id="email" name="email" required className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500 text-sm" data-id="element-864" data-mp="2arhueneri1yb" />
              </div>

              {/* Phone */}
              <div data-id="element-865" data-mp="qav5djamr5hk">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-900 mb-1" data-id="element-866" data-mp="qbmz0oko2t57">
                  Phone<span className="text-red-500" data-id="element-867" data-mp="320banljsoysr">*</span>
                </label>
                <input type="tel" id="phone" name="phone" required className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500 text-sm" data-id="element-868" data-mp="36wrwua7fp337" />
              </div>

              {/* Subject */}
              <div data-id="element-869" data-mp="2nadi6teu1mxr">
                <label htmlFor="subject" className="block text-sm font-medium text-gray-900 mb-1" data-id="element-870" data-mp="2navmmdbnf7gr">
                  Subject<span className="text-red-500" data-id="element-871" data-mp="2e84aebay87o2">*</span>
                </label>
                <input type="text" id="subject" name="subject" required className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500 text-sm" data-id="element-872" data-mp="7i6emdfmcsg8" />
              </div>

              {/* Message */}
              <div data-id="element-873" data-mp="23j85wg7v3z7t">
                <label htmlFor="message" className="block text-sm font-medium text-gray-900 mb-1" data-id="element-874" data-mp="1zjpldljydq5i">
                  Message<span className="text-red-500" data-id="element-875" data-mp="1uk4qbm7wm1y2">*</span>
                </label>
                <textarea id="message" name="message" rows={4} required className="block w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-brand-purple-500 focus:border-brand-purple-500 text-sm resize-none" data-id="element-876" data-mp="1pml6m6sfswyq" />
              </div>

              {/* reCAPTCHA Placeholder */}
              <div className="bg-gray-100 border border-gray-300 rounded-md p-3 flex items-center" data-id="element-877" data-mp="16tqtzjiadgxo">
                <input type="checkbox" id="recaptcha" className="h-5 w-5 text-brand-purple-600 focus:ring-brand-purple-500 border-gray-300 rounded mr-2" data-id="element-878" data-mp="11xa4akvfuuih" />
                <label htmlFor="recaptcha" className="text-xs text-gray-700" data-id="element-879" data-mp="3iki6xwo0p259">
                  I'm not a robot
                </label>
                <div className="ml-auto text-right" data-id="element-880" data-mp="3ritwrwh27vwn">
                  <div className="text-xs text-gray-500 font-medium" data-id="element-881" data-mp="3rial2xi063r2">
                    reCAPTCHA
                  </div>
                  <div className="text-xs text-gray-400" data-id="element-882" data-mp="2ur024kdwiz8e">Privacy - Terms</div>
                </div>
              </div>

              {/* Submit Button */}
              <button type="submit" className="w-full px-6 py-3 bg-brand-orange-400 text-brand-purple-900 font-bold rounded-md hover:bg-brand-orange-500 transition-colors shadow-md" data-id="element-883" data-mp="33spr7jkb9m30">
                Send Message
              </button>
            </form>

            <p className="mt-4 text-center text-sm text-gray-600" data-id="element-884" data-mp="2g2lxc3wxd0p7">
              We typically respond within 24 hours during business days
            </p>
          </Card>

          {/* Right Column - Contact Information */}
          <div className="space-y-6" data-id="element-885" data-mp="3edn84dt91ta5">
            {/* Need Help Section */}
            <div className="p-6 bg-gradient-to-br from-brand-purple-600 to-brand-purple-700 text-white rounded-xl shadow-sm" data-id="element-886" data-mp="3t446tpei253c">
              <h2 className="text-2xl font-bold mb-4" data-id="element-887" data-mp="3o7nh4qrnjio5">Need Help?</h2>
              <p className="text-brand-purple-100 mb-6" data-id="element-888" data-mp="30grndo3myde9">
                Our local support team is here to answer your questions about
                classes, requirements, or technical issues.
              </p>
              <a href="tel:602-377-6207" className="inline-flex items-center justify-center w-full bg-white text-brand-purple-900 px-6 py-3 rounded-full font-bold text-lg hover:bg-brand-orange-400 transition-colors shadow-lg" data-id="element-889" data-mp="39hzhdtz4cs2j">
                <Phone className="w-5 h-5 mr-2" data-id="element-890" data-mp="knsolyeqln6z" />
                602-377-6207
              </a>
              <p className="text-center text-brand-purple-100 text-sm mt-3 font-medium" data-id="element-891" data-mp="s7bk345638wg">
                Call, Text, Chat or Email us
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}